import { formatMomentToValueDate } from '../../../components/helpers/formatMomentToValueDate';
import { formatValueDateToMoment } from '../../../components/helpers/formatValueDateToMoment';
import { values } from '@morf/proto/values/v1/values_ts_proto';

export const generateDateRange = (
  startDate: values.v1.Date,
  endDate: values.v1.Date
): values.v1.Date[] => {
  const dates: values.v1.Date[] = [];

  let startMoment = formatValueDateToMoment(startDate);
  const endMoment = formatValueDateToMoment(endDate);

  const monthStartDay = startMoment.day();
  startMoment = startMoment.subtract(monthStartDay, 'd');

  while (startMoment.isSameOrBefore(endMoment)) {
    dates.push(formatMomentToValueDate(startMoment));
    startMoment = startMoment.add(1, 'd');
  }

  return dates;
};
